// Dependencies
import React from "react";
import { css } from "emotion";
import { Layout as AntdLayout } from "antd";
import MainMenu from "../components/MainMenu";
import Breadcrumb from "../components/Breadcrumb";
import FetchSpinnerProvider from "../context/FetchSpinner/FetchSpinnerProvider";
import Header from "./Header";
import withInitialData from "../HOC/withInitialData";

const DesktopLayout = ({ children }) => {
  return (
    <AntdLayout
      className={css`
        min-height: 100vh;
      `}
    >
      <Header />
      <MainMenu />
      <AntdLayout>
        <AntdLayout.Content
          className={css`
            margin: 0 16px;
          `}
        >
          <div
            className={css`
              margin: 16px 0;
            `}
          >
            <Breadcrumb />
          </div>
          <div
            className={css`
              padding: 24px;
              background-color: #fff;
            `}
          >
            <FetchSpinnerProvider>{children}</FetchSpinnerProvider>
          </div>
        </AntdLayout.Content>
        <AntdLayout.Footer
          className={css`
            text-align: center;
          `}
        >
          {`© RAGROM ${new Date().getFullYear()}`}
        </AntdLayout.Footer>
      </AntdLayout>
    </AntdLayout>
  );
};

export default withInitialData(DesktopLayout);
